function appendSort(url, sortBy, sortOrder) {
  if (sortBy) url.searchParams.append('sort_by', sortBy);
  if (sortOrder) url.searchParams.append('sort_order', sortOrder);
}

export async function fetchAccounts(csrfToken, query, page, sortBy, sortOrder) {
  const accountsUrl = '/sentinel_management/limited_roles/accounts';

  const url = new URL(accountsUrl, window.location.origin);
  url.searchParams.append('query', query);
  url.searchParams.append('page', page);
  appendSort(url, sortBy, sortOrder);

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'X-CSRF-Token': csrfToken,
    },
  });

  if (!response.ok) {
    const parsedResponse = await response.json();
    throw parsedResponse.message;
  }

  return response;
}

export async function fetchUsers(
  csrfToken,
  accountId,
  query,
  page,
  sortBy,
  sortOrder,
) {
  const usersUrl = '/sentinel_management/limited_roles/users';

  const url = new URL(usersUrl, window.location.origin);
  url.searchParams.append('account_id', accountId);
  url.searchParams.append('query', query);
  url.searchParams.append('page', page);
  appendSort(url, sortBy, sortOrder);

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'X-CSRF-Token': csrfToken,
    },
  });

  if (!response.ok) {
    const parsedResponse = await response.json();
    throw parsedResponse.message;
  }

  return response;
}

export async function toggleLimitedRole(csrfToken, accountId, userId) {
  const toggleUrl = '/sentinel_management/limited_roles/toggle_limited_role';

  const response = await fetch(toggleUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({ account_id: accountId, user_id: userId }),
  });

  if (!response.ok) {
    const parsedResponse = await response.json();
    throw parsedResponse.message;
  }

  return response;
}
